<template>
	<div class="newsLinkMain" :class="{ bigOne: size }">
		<div v-if="mankind.ContactType == 11 || mankind.ContactType == 10" class="newsHeadName"><img src="@/assets/img/group.png"></div>
		<div v-else class="newsHeadName" :style="{ backgroundColor: mankindColor(mankind.OnLine), color: mankindText(mankind.OnLine) }">{{ nameFormat(mankind.Name) }}</div>
		{{ mankind.Name}}
	</div>
</template>

<script>
	import { nameLastTwo } from '@/util/common'
	export default {
		name: 'linkItem',
		props: {
			mankind: {
				type: Object,
				default: {}
			},
			size:{
				type: Boolean,
				default: false
			},
		},
		data() {
			return {}
		},
		methods: {
			nameFormat(name) {
				return nameLastTwo(name)
			},
			mankindColor(online){
				return online ? '#d9e7ff' : '#e1e5ee'
			},
			mankindText(online){
				return online ? '#4081ff' : '#95989f'
			}
		},
	}
</script>

<style lang="less">
	@normalWidth: 32px;
	@largeWidth: 40px;
	.newsLinkMain {
		width: 100%;
		color: #4c4c4c;
		display: inline-block;
		height: @normalWidth;
		white-space: nowrap;
		font-size: 14px;
		text-overflow: ellipsis;
		line-height: @normalWidth;
		>div{
			margin-right: 5px;
		}
	}
	.bigOne{
		height: @largeWidth;
		line-height: @largeWidth;
	}
	.bigOne .newsHeadName{
		width: @largeWidth;
		height: @largeWidth;
	}
	.newsHeadName {
		display: inline-block;
		width: @normalWidth;
		height: @normalWidth;
		font-size: 12px;
		text-align: center;
		border-radius: 50%;
		color: #95989f;
		img {
			width: @normalWidth;
			height: @normalWidth;
			vertical-align: top;
		}
	}
</style>
